/**
 * @generated SignedSource<<33754ead4ca70820774e7caf7a4c3f9a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GiftCardsModalQuery$variables = {
  active?: boolean | null | undefined;
};
export type GiftCardsModalQuery$data = {
  readonly session: {
    readonly currentClientProfile: {
      readonly member: {
        readonly " $fragmentSpreads": FragmentRefs<"GiftCardsList_customer">;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type GiftCardsModalQuery = {
  response: GiftCardsModalQuery$data;
  variables: GiftCardsModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "active"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "active",
    "variableName": "active"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GiftCardsModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": (v1/*: any*/),
                        "kind": "FragmentSpread",
                        "name": "GiftCardsList_customer"
                      }
                    ],
                    "type": "Customer",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GiftCardsModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "allGiftCards",
                        "args": (v1/*: any*/),
                        "concreteType": "SquareGiftCardConnection",
                        "kind": "LinkedField",
                        "name": "squareGiftCards",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SquareGiftCardEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SquareGiftCard",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "balance",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "ganLastFour",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "status",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "squareId",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "createdAt",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Customer",
                    "abstractKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2abade4fc9928ed174bd8eb6f8788473",
    "id": null,
    "metadata": {},
    "name": "GiftCardsModalQuery",
    "operationKind": "query",
    "text": "query GiftCardsModalQuery(\n  $active: Boolean\n) {\n  session {\n    currentClientProfile {\n      __typename\n      member {\n        __typename\n        ... on Customer {\n          ...GiftCardsList_customer_2hYhrk\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment GiftCard_squareGiftCard on SquareGiftCard {\n  __typename\n  id\n  balance\n  ganLastFour\n  status\n  squareId\n  createdAt\n}\n\nfragment GiftCardsList_customer_2hYhrk on Customer {\n  allGiftCards: squareGiftCards(active: $active) {\n    edges {\n      node {\n        ...GiftCard_squareGiftCard\n        id\n        balance\n        status\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "11088ec67a8c2b678009a37f77a4464b";

export default node;
